import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Spinner } from "@/components/common";
import { CompartirAcceso } from "@/components/CompartirAcceso";
import { KeyRound, MessageCircle, RotateCcw, Power, X, UserPlus } from "lucide-react";

import { URL_ROGE } from "@/lib/dominio";
const ESTADOS = {
  sin_acceso: ["Sin acceso", "bg-slate-100 text-slate-600"],
  activo: ["Acceso activo", "bg-emerald-50 text-emerald-700"],
  inactivo: ["Acceso inactivo", "bg-amber-50 text-amber-700"],
};

export function AccesoBadge({ estado, testid }) {
  const [l, c] = ESTADOS[estado] || ESTADOS.sin_acceso;
  return <span data-testid={testid} className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${c}`}>{l}</span>;
}

export function mensajeWhatsApp(nombre, email) {
  return [
    `¡Hola, ${nombre}! 👋🐈‍⬛`, "",
    "¡Bienvenido a *Roge by Human RMSA*! 💙", "",
    "Ya tienes habilitado tu acceso a nuestro portal de empleados.", "",
    "Desde allí podrás consultar tu información laboral, documentos, certificaciones y demás funcionalidades disponibles.", "",
    "🔐 *Tus credenciales de acceso son:*", "",
    `📧 *Usuario:* ${email}`, "",
    `🔑 *Contraseña:* ${email}`, "",
    `🌐 *Ingresa aquí:* ${URL_ROGE}`, "",
    "Si lo deseas, podrás cambiar tu contraseña desde tu perfil al ingresar a la plataforma.", "",
    "🐈‍⬛ *¡Bienvenido a Roge!*", "",
    "*HUMAN RESOURCES MANAGMENT SA* 💙",
  ].join("\n");
}

export function waUrl(celular, texto) {
  let d = (celular || "").replace(/\D/g, "");
  if (d.length === 10) d = "57" + d;
  return `https://api.whatsapp.com/send?phone=${d}&text=${encodeURIComponent(texto)}`;
}

function Panel({ vid, onClose, onChange }) {
  const [a, setA] = useState(null);
  const [f, setF] = useState({ email: "", celular: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/vinculaciones/${vid}/acceso`).then((r) => { setA(r.data); setF({ email: r.data.email || "", celular: r.data.celular || "" }); }).catch((e) => { toast.error(formatApiErrorDetail(e.response?.data?.detail)); onClose(); });
  }, [vid, onClose]);
  const [token, setToken] = useState(null);
  const run = async (fn, ok) => {
    setBusy(true);
    try { const r = await fn(); setA(r.data); onChange?.(r.data.estado); if (r.data.activacion_token) setToken(r.data.activacion_token); toast.success(ok); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const restablecer = () => window.confirm(`¿Generar un nuevo enlace de activación para ${a.nombre}? Su contraseña actual dejará de funcionar y sus sesiones se cerrarán.`) && run(() => api.post(`/vinculaciones/${vid}/acceso/restablecer`), "Enlace generado. Ya puedes enviarlo por WhatsApp.");
  const toggle = () => {
    const activar = a.estado === "inactivo";
    if (window.confirm(activar ? `¿Activar el acceso de ${a.nombre}?` : `¿Desactivar el acceso de ${a.nombre}? No podrá ingresar a Roge hasta que lo actives.`))
      run(() => api.patch(`/vinculaciones/${vid}/acceso/estado`, { activo: activar }), activar ? "Acceso activado" : "Acceso desactivado");
  };
  const btn = "flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium disabled:opacity-50";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white p-5 shadow-xl" data-testid="gestionar-acceso-modal">
        <div className="mb-3 flex items-center justify-between"><p className="font-semibold text-slate-800">Gestionar acceso</p><button onClick={onClose} data-testid="gestionar-acceso-cerrar" className="rounded p-1 text-slate-400 hover:bg-slate-100"><X className="h-5 w-5" /></button></div>
        {!a ? <div className="flex h-32 items-center justify-center text-vino-700"><Spinner className="h-6 w-6" /></div> : (
          <div className="space-y-4">
            <div className="flex items-start justify-between gap-2"><div><p className="text-sm font-semibold text-slate-800">{a.nombre}</p><p className="text-xs text-slate-500">CC {a.cedula}</p></div><AccesoBadge estado={a.estado} testid="acceso-estado" /></div>
            {a.estado === "sin_acceso" ? (
              <>
                <div className="space-y-3">
                  <div><label className="mb-1 block text-xs font-medium text-slate-500">Correo electrónico (será usuario y contraseña) *</label><input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="acceso-email" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" /></div>
                  <div><label className="mb-1 block text-xs font-medium text-slate-500">Celular / WhatsApp *</label><input value={f.celular} onChange={(e) => setF({ ...f, celular: e.target.value })} data-testid="acceso-celular" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" /></div>
                  {(!a.email || !a.celular) && <p className="text-xs text-amber-700">Completa los datos que faltan para crear el acceso. No se modifica la información laboral del empleado.</p>}
                </div>
                <button disabled={busy} onClick={() => run(() => api.post(`/vinculaciones/${vid}/acceso`, f), "Acceso creado. Comparte el enlace de activación.")} data-testid="acceso-crear" className={`${btn} w-full bg-vino-700 text-white hover:bg-vino-800`}>{busy ? <Spinner className="h-4 w-4" /> : <UserPlus className="h-4 w-4" />} Crear acceso</button>
              </>
            ) : (
              <>
                <div className="rounded-lg bg-slate-50 p-3 text-sm"><p><span className="text-slate-500">Usuario:</span> <strong data-testid="acceso-usuario">{a.email}</strong></p><p><span className="text-slate-500">WhatsApp:</span> {a.celular || "—"}</p>
                  <p className="text-xs text-slate-500">{a.password_predeterminada ? "Debe cambiar su contraseña al ingresar." : "Las contraseñas nunca se muestran ni se envían."}</p></div>
                <div className="grid gap-2">
                  <button onClick={restablecer} disabled={busy || a.estado !== "activo"} data-testid="acceso-restablecer" className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`}><MessageCircle className="h-4 w-4" /> Generar enlace y enviar por WhatsApp</button>
                  <button onClick={toggle} disabled={busy} data-testid="acceso-toggle" className={`${btn} border ${a.estado === "inactivo" ? "border-emerald-200 text-emerald-700 hover:bg-emerald-50" : "border-amber-200 text-amber-700 hover:bg-amber-50"}`}><Power className="h-4 w-4" /> {a.estado === "inactivo" ? "Activar acceso" : "Desactivar acceso"}</button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {token && a && <CompartirAcceso nombre={a.nombre} email={a.email} role="empleado" telefono={a.celular} token={token} onClose={() => setToken(null)} />}
    </div>
  );
}

export function GestionarAccesoBtn({ vid, onChange, compact }) {
  const [open, setOpen] = useState(false);
  const cerrar = useCallback(() => setOpen(false), []);
  return (
    <>
      <button onClick={(e) => { e.stopPropagation(); setOpen(true); }} data-testid={`btn-gestionar-acceso-${vid}`} title="Gestionar acceso"
        className={compact ? "rounded-lg p-2 text-slate-400 hover:bg-vino-50 hover:text-vino-700" : "flex items-center gap-1.5 rounded-lg border border-vino-200 bg-white px-3 py-1.5 text-xs font-semibold text-vino-700 hover:bg-vino-50"}>
        <KeyRound className="h-4 w-4" />{!compact && " Gestionar acceso"}
      </button>
      {open && <Panel vid={vid} onClose={cerrar} onChange={onChange} />}
    </>
  );
}
